"use client"

import { MessagesSquare } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessagesSquareIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessagesSquareIcon = component(Icon)({ as: MessagesSquare })
